import { authStore } from '@/stores/auth.js'
import { layoutStore } from '@/stores/layout.js'
import { notifStore } from '@/stores/notif.js'
import { nextTick } from 'vue'
import moment from 'moment';
import MobileDetect from 'mobile-detect';


export default {
    clearCookies() {
        const cookies = document.cookie.split(";");

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i];
            const equalsPos = cookie.indexOf("=");
            const name = equalsPos > -1 ? cookie.substr(0, equalsPos) : cookie;
            document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
        }

        console.log("All cookies cleared.");
    },
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },
    getFeature(menu, feature) {
        const layout = layoutStore();
        const menus = layout.menus;
        if (menus != undefined && menus != null) {
            let filteredMenus = menus.filter(v => v.name === menu);
            if (filteredMenus[0]) {
                if (feature != "") {
                    let filteredFeature = filteredMenus[0].childrens.filter(v => v.name === feature);
                    if (filteredFeature[0]) {
                        return true
                    }
                } else {
                    return true
                }
            }
        }


        return false
    },
    addNumbSep(number, thouSep) {
        return number.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thouSep)
    },

    formatMoney(number, options) {
        let { thouSep, decSep, decimal } = options || {}
        thouSep = thouSep || ','
        decSep = decSep || '.'
        decimal = isNaN(decimal) ? 0 : Math.abs(decimal)

        let _nSplits = (Number(number) || 0).toFixed(decimal).split('.')
        let _numbStr = _nSplits[0]
        let _decStr = _nSplits.length > 1 ? _nSplits[1] : ""
        _numbStr = this.addNumbSep(_numbStr, thouSep)

        return _numbStr + (_decStr ? decSep + _decStr : "")
    },

    showInfo(message, autoHide, title) {
        const notif = notifStore()
        notif.create({
            kind: 'success',
            title: title && title != '' ? title : 'INFO',
            autoHide: autoHide ? autoHide : 5000,
            message: message
        })
        setTimeout(() => {
            notif.hide()
        }, 3000)
    },

    showError(message, autoHide, title) {
        const notif = notifStore()
        notif.create({
            kind: 'error',
            title: title && title != '' ? title : 'ERROR',
            message: this.getErrorMessage(message)
        })
        setTimeout(() => {
            notif.hide()
        }, 3000)
    },

    getErrorMessage(e) {
        if (e == undefined || e == null) return "uknown error"

        const msg =
            e.response && e.response.data && e.response.data.message ? e.response.data.message :
                e.response && e.response.data && e.response.data.error ? e.response.data.error.message :
                    e.response && e.response.data && e.response.data.detail ? e.response.data.detail :
                        e.response && e.response.data ? e.response.data :
                            e.data && e.data.message ? e.data.message :
                                e.message ? e.message :
                                    e.reason ? e.reason :
                                        e.error ? e.error : e

        return msg
    },

    isMobile() {
        const md = new MobileDetect(window.navigator.userAgent);
        return !!md.mobile();
    },

    useLayout(name) {
        const layout = layoutStore()
        layout.name = name
    },

    nextTickN(n, f) {
        if (n == 0) {
            nextTick(() => {
                f()
            })
        } else {
            nextTick(() => {
                this.nextTickN(n - 1, f)
            })
        }
    },

    getAge(dob) {
        console.log(dob);
        var diff_ms = Date.now() - dob.getTime();
        var age_dt = new Date(diff_ms);
        console.log(age_dt)
        return Math.abs(age_dt.getUTCFullYear() - 1970);
    },

    uuid() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0,
                v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    },
    generateDateList(startDate, endDate) {
        const dateList = [];
        let currentDate = moment(startDate);

        while (currentDate.isSameOrBefore(endDate)) {
            dateList.push(currentDate.format('YYYY-MM-DD'));
            currentDate.add(1, 'days'); // Increment by one day
        }

        return dateList;
    },
    formatDateFilter(value, format = 'YYYY-MM-DD') {
        return value ? moment(value).utcOffset('+08:00').format(format) : '';
    },
    formatDate(value, format = 'DD MMM YYYY') {
        return value ? moment(value).utcOffset('+08:00').format(format) : '';
    },
    formatTime(value, format = 'hh:mm A') {
        return value ? moment(value).utcOffset('+08:00').format(format) : '';
    },
    formatDateTime(value, format = 'DD MMM YYYY hh:mm A') {
        return value ? moment(value).utcOffset('+08:00').format(format) : '';
    },
    formattedCategoryHazard(v) {
        const categoryHazard = v || '';
        // Replace underscores with spaces and then spaces with " - "
        return categoryHazard
            .split(' ') // Split by spaces
            .map(term =>
                term
                    .replace(/_/g, ' ') // Replace underscores with spaces
                    .replace(/\b\w/g, char => char.toUpperCase()) // Capitalize the first character of each word
            )
            .join(' - '); // Join terms with " - "
    }
}